import { useMemo, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import Button from '../components/common/Button'

const isSafeHttpsUrl = (value) => {
  if (!value) return false
  try {
    const url = new URL(value)
    return url.protocol === 'https:'
  } catch {
    return false
  }
}

const Checkout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const checkoutUrl = useMemo(() => {
    const fromState = location.state?.checkoutUrl
    if (fromState) return fromState
    try {
      return sessionStorage.getItem('checkoutUrl') || ''
    } catch {
      return ''
    }
  }, [location.state])

  const message = location.state?.message
  const userEmail = location.state?.user?.email

  const canContinue = isSafeHttpsUrl(checkoutUrl)

  const onContinue = () => {
    if (!canContinue) return
    setIsRedirecting(true)
    window.location.assign(checkoutUrl)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary to-primary-dark rounded-2xl mb-4 shadow-lg">
            <Icon icon="mdi:credit-card-check" className="text-3xl text-white" />
          </div>
          <h1 className="text-3xl font-bold text-text-dark mb-2">Checkout</h1>
          <p className="text-text-secondary">Complete payment to activate your account.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-border-light">
          {message && (
            <div className="mb-4 p-3 bg-primary/10 border border-primary/20 rounded-lg text-sm text-primary-dark">
              {message}
            </div>
          )}

          {userEmail && (
            <p className="text-sm text-text-secondary mb-6">
              Account: <span className="font-semibold text-text-dark">{userEmail}</span>
            </p>
          )}

          {!canContinue && (
            <div className="mb-6 p-3 bg-danger/10 border border-danger/20 rounded-lg text-sm text-danger">
              Checkout link is missing or invalid. Please register again.
            </div>
          )}

          <div className="space-y-3">
            <Button
              className="w-full"
              icon="mdi:arrow-right"
              iconPosition="right"
              onClick={onContinue}
              disabled={!canContinue || isRedirecting}
            >
              {isRedirecting ? 'Redirecting...' : 'Continue to Secure Checkout'}
            </Button>

            <Button
              variant="secondary"
              className="w-full"
              onClick={() => navigate('/plans')}
            >
              Back to Plans
            </Button>
          </div>

          <div className="mt-6 text-center">
            <Link to="/login" className="text-sm text-primary hover:text-primary-dark font-medium">
              Back to Login
            </Link>
          </div>
        </div>

        <div className="mt-6 text-center text-sm text-text-secondary">
          <p>Â© 2024 SentryPrime. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default Checkout

